// import constants types
import {
    UNIT_TYPE_EVENTS_SHOW,
    UNIT_TYPE_EVENTS_SHOW_RESULT,
    UNIT_TYPE_EVENTS_SHOW_HIDE,
    CLEAR_REDUX,
} from 'Redux/actionTypes';


// initial state
const INIT_STATE = {
    result: null,
    loading: false,
    openModal: false,
    loading: false,
    unitType: null
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {

        case UNIT_TYPE_EVENTS_SHOW:
            return { ...state, loading: true, openModal: true, unitType: action?.payload };

        case UNIT_TYPE_EVENTS_SHOW_RESULT:
            return {
                ...state,
                openModal: true,
                loading: false,
                result: action?.payload

            };
        case UNIT_TYPE_EVENTS_SHOW_HIDE:
            return { ...INIT_STATE, openModal: false, loading: false };

        case CLEAR_REDUX:
            return ["", "UNIT_TYPE_EVENTS"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};
